const defaultState={
    token: undefined
};

export default (state=defaultState, action)=>{
    switch (action.type){
        case 'LOGIN':
            return {...state, token: action.token}
        case 'LOGOUT':
            return {...state, token: undefined}
        case "SET_USERNAME":
            return {...state, username : action.username}
        case "SET_PASSWORD":
            return {...state, password : action.password}
        default:
            return state;
        }
}